module.exports = __webpack_public_path__ + "media/images/action_edit-f73a8868d84d44afdf7eae8d80c7e668.png";